export default {
    isNull(data) {
        if (typeof data === 'number') {
            return false;
        } else if (typeof data === 'string') {
            return data.trim() === '';
        } else if (Array.isArray(data)) {
            return !(data.length > 0);
        }
        return !data;
    },
    getWindowHeight() {
        let windowHeight = 0;
        if (document.compatMode === 'CSS1Compat') {
            windowHeight = document.documentElement.clientHeight;
        } else {
            windowHeight = document.body.clientHeight;
        }
        return windowHeight;
    },
    getScrollHeight() {
        let scrollHeight = 0;
        let bSH = 0;
        let dSH = 0;
        if (document.body) {
            bSH = document.body.scrollHeight;
        }
        if (document.documentElement) {
            dSH = document.documentElement.scrollHeight;
        }
        scrollHeight = (bSH - dSH > 0) ? bSH : dSH;
        return scrollHeight;
    },
    getScrollTop() {
        let scrollTop = 0;
        let bodyScrollTop = 0;
        let documentScrollTop = 0;
        if (document.body) {
            bodyScrollTop = document.body.scrollTop;
        }
        if (document.documentElement) {
            documentScrollTop = document.documentElement.scrollTop;
        }
        scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
        return scrollTop;
    },
};
